import { Component, OnInit, ViewChild } from '@angular/core';
import { GridComponent, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs';
import { clientTemplate, employeeTemplate, onBoardingtemplateBO } from '../agreement-template/agreement-template.model';
import { AgreementTemplateService } from '../agreement-template/agreement-template.service';
import { ClientHttpService } from '../client-parent/client-parent.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { takeUntil } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
// import { HandBookSaveBo } from './handbook.model';
import { HandBookService } from './handbook.service';
import { GetHandbookBO, HandbookBO, functionpermission } from './handbook.model';
import { DomSanitizer } from '@angular/platform-browser';
import { PurchaseRequestService } from '../purchase-request/purchase-request.service';

@Component({
  selector: 'app-handbook',
  templateUrl: './handbook.component.html',
  styleUrls: ['./handbook.component.scss']
})
export class HandbookComponent implements OnInit {

 
  @ViewChild('grid') public grid: GridComponent;
  @ViewChild('gridEmp') public gridEmp: GridComponent;

  public pageSettings: PageSettingsModel;
  public filterOption: object;
 
  public data: any;
  gridData: any;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];

  private onDestroy$: Subject<void> = new Subject<void>();
  gridTemplateBO: GetHandbookBO = new GetHandbookBO()
  ClientTemplateBO: clientTemplate = new clientTemplate()
  employeeTemplateBO: employeeTemplate = new employeeTemplate()
  fp: functionpermission = new functionpermission()
  isSaveorUpdateBoolean:boolean=false;
  statusList: any = [];
  public TemplateList = []

  emit_boolean = false
  agencycheck: false
  allEmployeeDropDown:any=[]
  allClientDropDown:any=[]
  formatDateOptions:Object;
  @ViewChild('edithandbookFile') nameInput: any;

  constructor(public DataService: HandBookService, public clientservice: ClientHttpService, 
    public global: GlobalComponent, private toast: ToastrService,private sanitizer:DomSanitizer,
 private purchaseService: PurchaseRequestService

  ) {
    this.global.checkforlogout();
    this.data = DataService;
  }

  ngOnInit(): void {
    this.formatDateOptions = { type: "date", format: "MM/dd/yyyy" };

    if (
      (this.global.globalAgencyId == null ||
        this.global.globalAgencyId == undefined ||
        this.global.globalAgencyId == "" ||
        this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") && (this.global.agencyCode == 'SUPERADMIN')) {
      return;
    }
    this.getHandBookList();
   
    this.pageSettings = {
      currentPage: 1,
      totalRecordsCount: 0,
      pageCount: 10,
      pageSize: this.pageSizes[0],
      pageSizes: this.pageSizes,
    };
    this.filterOption = {
      type: "Menu",
    };
    this.getpermission();
 
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '')) {
      let params = new URLSearchParams();
      params.append("pagecode", "HANDBOOK");
      params.append("roleId", this.global.roleId);
      params.append("agencyId", this.global.globalAgencyId)
      this.DataService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        if (data != null) {
          this.fp = data;
        }
        else {
          this.fp = new functionpermission();
        }
      },
        (err: HttpErrorResponse) => {
          this.fp = new functionpermission();
        })
    }
  }
  getAllEmployeeDropDown() {

     let params=new URLSearchParams();
     params.append("agencyId",this.global.globalAgencyId);
    this.DataService.GetAllEmployeeForAgencyHandBook(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data != null) {
        this.allClientDropDown = data;
        console.log("allEmployeeDropDown",this.allEmployeeDropDown);
      }
    
    },
      (err: HttpErrorResponse) => {
       
      })

  }

 

 

  /////////////////////// Edit Template ////////////////////
  edit(data) {
    document.getElementById("templateNameModal").click();
    console.log(data);
    this.documentList=new HandbookBO();
   this.documentList.filePath=data.filePath;
   this.documentList.handbookName=data.handbookName;
   this.documentList.id=data.id;
   this.documentList.fileName=data.fileName;
   
   this.selectedDocumentFileName=data.fileName;
  
   this.documentList.type=(data.type != null && data.type != undefined) ? data.type:null;
   let basevalue:any;
   if (data.returnString != null && data.returnString != undefined) {  

      let base64Url: string;
  let finalString:string;
  const mimeType =this.getMimeType(this.documentList.fileName);
  console.log(mimeType,"mimeType");
  if(mimeType != '' && mimeType != undefined) {  
   
    let params = new URLSearchParams();  
     params.append("HandbookId", data.id);
    const url = "api/HandBook/getHandbookDocBase64?";
  this.DataService.GetViewHandBook(params, url)
    .pipe(takeUntil(this.onDestroy$))
    .subscribe((data: any) => {
      if (data) {
        try {  

         finalString = `data:${mimeType};base64,${data}`;
          console.log(finalString,"finalString");
         this.documentList.fileString=finalString;  
        this.setFileFromBase64(finalString,mimeType,this.documentList.fileName)

          
        } catch (err) {
          console.error("Failed to decode PDF URL", err);
        }
      }
    }, (err: any) => {
        this.toast.error(err), 8000;     
    });
  }
 


  }
  }
   getMimeType(fileName: string): string {
    // Extract the file extension
    if(fileName==null && fileName == undefined) {
        return ''
    }
   // let extention=fileName.split(".");
    const lastDotIndex = fileName.lastIndexOf('.');

const baseName = fileName.substring(0, lastDotIndex); 
const extension = fileName.substring(lastDotIndex + 1); 
    const ext = extension.toLowerCase();
    console.log(ext,"ext")
    // Map file extensions to MIME types
    const mimeTypes: { [key: string]: string } = {
        'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'xls': 'application/vnd.ms-excel',
        'csv': 'text/csv',    
        'pdf': 'application/pdf',   
        'jpeg': 'image/jpeg',  
        'jpg': 'image/jpeg',  
        'png': 'image/png',   
    };   
    return mimeTypes[ext]; 
}
setFileFromBase64(fialstring,mimeType,filename): void {
      // Decode the base64 string and create a Blob
      const base64Data = fialstring.split(',')[1]; 
      const binaryData = atob(base64Data); 
  
     
      const arrayBuffer = new ArrayBuffer(binaryData.length);
      const uint8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < binaryData.length; i++) {
        uint8Array[i] = binaryData.charCodeAt(i);
      }
  
     
      const blob = new Blob([uint8Array], { type: mimeType });
  
      // Create a File object from the Blob
//       var splittedstr=mimeType.split("/")

//       let str1: string = "data";
// let str2: string = splittedstr[1];
// let result: string = str1.concat(str2);
      const file = new File([blob], filename, { type: mimeType });
  
     
      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);
  
     
      this.nameInput.nativeElement.files = dataTransfer.files;
    }
  getHandBookList() {
    console.log(this.global.LoginEntityType,"this.global.LoginEntityType");
    //if(this.global.LoginUserType)
    this.gridTemplateBO.agencyId = (this.global.globalAgencyId != "" && this.global.globalAgencyId != null && this.global.globalAgencyId != undefined) ? this.global.globalAgencyId : "00000000-0000-0000-0000-000000000000"
    this.gridTemplateBO.viewtype=this.global.LoginEntityType;
    this.DataService.executeClient(this.gridTemplateBO);
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.gridData = data.result;
    },
      (err: any) => {
        this.toast.error(err.error.Request, "error");
      });
    
  }
  ///////////////////////template type////////////////////

 

  refresh() {
    this.getHandBookList();
  }

  //........................................TAPCHANGE.......................................
  PrivatePaySelectedTab = 'Client'

 

  clearName() {
    this.ClientTemplateBO.templatename = ''
    this.employeeTemplateBO.templateName = ''
    this.ClientTemplateBO.datalist = ''
    this.employeeTemplateBO.datalist = ''
     this.selectedDocumentFileName =null;
     this.documentList = new HandbookBO();
  }

  dataChangeAgreement(temp) {
    let val = temp.action.requestType.toString();
    if (val != "filterchoicerequest") {
      if ((temp.sorted || []).length) {
        this.gridTemplateBO.orderColumn = temp.sorted[0].name;
        this.gridTemplateBO.orderType =
          temp.sorted[0].direction === "descending" ? "DESC" : "ASC";
      }
    }
    if (val == "filtering" && temp.action.action != "clearFilter") {
      this.gridTemplateBO.value = temp.action.currentFilterObject.value;
      this.gridTemplateBO.field = temp.action.currentFilterObject.field;
      this.gridTemplateBO.matchCase = temp.action.currentFilterObject.matchCase;
      this.gridTemplateBO.operator = temp.action.currentFilterObject.operator;
      if (this.gridTemplateBO.type == "number") {
        this.gridTemplateBO.value =
          temp.action.currentFilterObject.value.toString();
        this.gridTemplateBO.field = temp.action.currentFilterObject.field;
      }
    } else {
      if (val == "filtering" && temp.action.action == "clearFilter") {
        this.gridTemplateBO.field = "handbookName";
        this.gridTemplateBO.matchCase = false;
        this.gridTemplateBO.operator = "contains";
        this.gridTemplateBO.value = "";
        this.gridTemplateBO.type = "string";
      }
    }
    this.getHandBookList();
  }

  onActionAgreement(r) {
    this.gridTemplateBO.currentpageno =
      this.grid.pagerModule.pagerObj.currentPage;
    this.gridTemplateBO.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    if (r.name == "actionBegin" && r.requestType == "filterbeforeopen") {
      this.gridTemplateBO.type = r.columnType;
    }
  }

  showColumns() {
    this.grid.columnChooserModule.openColumnChooser(200, 50);
  }

  showColumnsOne() {
    this.gridEmp.columnChooserModule.openColumnChooser(200, 50);
  }

  dataChangeAgreementEmp(temp) {
    let val = temp.action.requestType.toString();
    if (val != "filterchoicerequest") {
      if ((temp.sorted || []).length) {
        this.gridTemplateBO.orderColumn = temp.sorted[0].name;
        this.gridTemplateBO.orderType =
          temp.sorted[0].direction === "descending" ? "DESC" : "ASC";
      }
    }
    if (val == "filtering" && temp.action.action != "clearFilter") {
      this.gridTemplateBO.value = temp.action.currentFilterObject.value;
      this.gridTemplateBO.field = temp.action.currentFilterObject.field;
      this.gridTemplateBO.matchCase = temp.action.currentFilterObject.matchCase;
      this.gridTemplateBO.operator = temp.action.currentFilterObject.operator;
      if (this.gridTemplateBO.type == "number") {
        this.gridTemplateBO.value =
          temp.action.currentFilterObject.value.toString();
        this.gridTemplateBO.field = temp.action.currentFilterObject.field;
      }
    } else {
      if (val == "filtering" && temp.action.action == "clearFilter") {
        this.gridTemplateBO.field = "handbookName";
        this.gridTemplateBO.matchCase = false;
        this.gridTemplateBO.operator = "contains";
        this.gridTemplateBO.value = "";
        this.gridTemplateBO.type = "string";
      }
    }
    this.getHandBookList();

  }

  onActionAgreementEmp(r) {
    this.gridTemplateBO.currentpageno =
    this.gridEmp.pagerModule.pagerObj.currentPage;
    this.gridTemplateBO.pageitem = this.gridEmp.pagerModule.pagerObj.pageSize;
    if (r.name == "actionBegin" && r.requestType == "filterbeforeopen") {
      this.gridTemplateBO.type = r.columnType;
    }
  }
  documentList:HandbookBO =new HandbookBO();
  typeList:any=[
   {
        "name": "Client",
        "value": "Client"
    },
    {
        "name": "Employee",
        "value": "Employee"
    },
    {
        "name": "Client and Employee",
        "value": "Client and Employee"
    }
  ]
  selectedDocumentFileName:any;
  onDOCFileChanged(files) {
    
    let val = files.item(0);
    console.log(val,'val---');
   if(this.documentList.id != "00000000-0000-0000-0000-000000000000")
        this.documentList.fileString= undefined;
    this.documentList.fileString = files.item(0);   
    this.selectedDocumentFileName = files.item(0)?.name;
    this.documentList.fileName= files.item(0)?.name;
    if(files.item(0)?.length==0){
      this.selectedDocumentFileName=''
    }
  }
  pdfsrc:any;
async  savehandbook(val) {
  this.isSaveorUpdateBoolean=true;
    console.log("val",val);
    let basevalue: any;
    console.log(typeof(this.documentList.fileString));
    if (typeof(this.documentList.fileString) == 'object' && val.fileString != null && val.fileString != undefined) {
      basevalue = await this.tobase64(this.documentList.fileString);
      console.log("basevalue",basevalue);
      val.fileString = basevalue;
    }
    this.DataService.SaveHandbook(val).pipe(takeUntil(this.onDestroy$)).subscribe(
     
      (data: any) => {
        this.isSaveorUpdateBoolean=false;
       if(data) {
        document.getElementById("templateNameModal").click();
        if(val.id == "00000000-0000-0000-0000-000000000000")
            this.toast.success("Handbook Saved Successfully","Handbook Saved");
        else 
            this.toast.success("Handbook Updated Successfully","Handbook Updated");
        this.getHandBookList();
       }

      }, (err: any) => {
        this.isSaveorUpdateBoolean=false;
       console.log(err)
       this.toast.error(err), 8000;

      });
  }
  
  tobase64 = value => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(value);
    reader.onload = (e: any) => resolve(e.target.result);
    reader.onerror = error => reject(error);
  });
  downloadFile(data) {
    var data1 = data.returnString;
    if (data1 != null) {
      window.open(data1);
    }
   
  }
  deletedId:any;
  deleteHandbook(Deletedid) {
      this.deletedId=Deletedid;
  }
  Delete() {
    let param = new URLSearchParams()
    param.append("HandBookId", this.deletedId)
    this.DataService .DeleteHandBook(param).subscribe((data: any) => {
      this.toast.success("Handbook Deleted successfully!");
      document.getElementById("openHandbookdelete").click();
     this.getHandBookList();
    },
      (err: any) => {
        if (err) {
          this.toast.error(err, 'Error'), 8000;
        }
      })
  }
  getViewHandBook(HandbookId: string) {
  let params = new URLSearchParams();
  this.pdfsrc = null;
  params.append("HandbookId", HandbookId);
  const url = "api/HandBook/getHandbookDocBase64?";

  this.DataService.GetViewHandBook(params, url)
    .pipe(takeUntil(this.onDestroy$))
    .subscribe((data: any) => {
      if (data) {
        try {   
          const decodedUrl = atob(data); 
       this.pdfsrc = this.sanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + data);

         
        
          console.log("PDF loaded from:", decodedUrl);
        } catch (err) {
          console.error("Failed to decode PDF URL", err);
        }
      }
    }, (err: any) => {
       console.log(err);      
        this.toast.error(err), 8000;
    });
}

}
